import script from "./LlDataTablePagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./LlDataTablePagination.vue?vue&type=script&setup=true&lang=ts"

import "./LlDataTablePagination.vue?vue&type=style&index=0&id=4916c46a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4916c46a"]])

export default __exports__